<template>
    <div>
        <h2>404 YOU HAVE LOST!!</h2>
    </div>
</template>